import { render } from "./MainSidebar.vue?vue&type=template&id=1a9403c3"
import script from "./MainSidebar.vue?vue&type=script&lang=js"
export * from "./MainSidebar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__